import * as index from './index';
index.InPlaceEditor.Inject(index.AutoComplete, index.ColorPicker, index.ComboBox, index.DateRangePicker, index.MultiSelect, index.Rte, index.Slider, index.TimePicker);
export * from './index';
